// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGallaryMini_root__wZygV {
  margin-top: 36px;
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_title__FgHZ7 {
  margin: 12px 0;
  font-size: 16px;
  letter-spacing: 0.1px;
  color: rgba(17, 17, 17, 0.8392156863);
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x .MediaGallaryMini_files__xKUPH {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x .MediaGallaryMini_files__xKUPH .MediaGallaryMini_file__q-qzy {
  border: solid 1px #dedede;
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x .MediaGallaryMini_files__xKUPH .MediaGallaryMini_file__q-qzy img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x .MediaGallaryMini_file__q-qzy,
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x .MediaGallaryMini_all__v5OSn {
  width: 96px;
  height: 96px;
}
.MediaGallaryMini_root__wZygV .MediaGallaryMini_content__H82-x .MediaGallaryMini_all__v5OSn {
  display: flex;
  align-items: center;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/MediaGallaryMini/MediaGallaryMini.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAAE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AAEJ;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAEJ;AADI;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAGN;AAFM;EACE,yBAAA;AAIR;AAHQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAKV;AADI;;EAEE,WAAA;EACA,YAAA;AAGN;AADI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAGN","sourcesContent":[".root {\r\n  margin-top: 36px;\r\n  .title {\r\n    margin: 12px 0;\r\n    font-size: 16px;\r\n    letter-spacing: 0.1px;\r\n    color: #111111d6;\r\n  }\r\n  .content {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    .files {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 24px;\r\n      .file {\r\n        border: solid 1px #dedede;\r\n        img {\r\n          width: 100%;\r\n          height: 100%;\r\n          object-fit: cover;\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n    .file,\r\n    .all {\r\n      width: 96px;\r\n      height: 96px;\r\n    }\r\n    .all {\r\n      display: flex;\r\n      align-items: center;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MediaGallaryMini_root__wZygV`,
	"title": `MediaGallaryMini_title__FgHZ7`,
	"content": `MediaGallaryMini_content__H82-x`,
	"files": `MediaGallaryMini_files__xKUPH`,
	"file": `MediaGallaryMini_file__q-qzy`,
	"all": `MediaGallaryMini_all__v5OSn`
};
export default ___CSS_LOADER_EXPORT___;
